export default __webpack_public_path__ + "static/media/Community-Living-Key-Information-Document-1-April-2023.c3bde03c.pdf";